import { Record } from 'immutable';

import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';

export const TICKER_LOGOS_REDUCER_KEY = 'tickerLogosStore';
export const TICKER_LOGOS_VERSION_NUMBER = 2;

export type TickerLogoProps = {
  id?: string;
  ticker?: string;
  logoUrl?: string;
  modifiedAt?: string;
};

export const mkTickerLogo = Record<TickerLogoProps>({
  id: undefined,
  ticker: undefined,
  logoUrl: '',
  modifiedAt: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [TICKER_LOGOS_REDUCER_KEY]: QcsSyncResourceStore<TickerLogoProps>;
  }
}
